import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { FormattedMessage } from '../../../util/reactIntl';

import { Modal, IconEdit, IconDelete } from '../../../components';

import YoutubeSectionForm from './YoutubeSectionForm';
import css from './YoutubeSection.module.scss';


const Swiper =
  typeof window !== 'undefined'
    ? require('swiper/react').Swiper
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const SwiperSlide =
  typeof window !== 'undefined'
    ? require('swiper/react').SwiperSlide
    : dynamic(() => import('swiper/react'), {
      ssr: false,
    });
const Navigation =
  typeof window !== 'undefined'
    ? require('swiper').Navigation
    : dynamic(() => import('swiper'), {
      ssr: false,
    });

const YoutubeSection = props => {
  const {
    publicData,
    listing,
    isOwnListing,
    onManageDisableScrolling,
    onUpdateListing,
    onLoadData,
    id,
    slug,
    intl,
    isPreview
  } = props;

  const videos = !!publicData?.videos?.length && publicData.videos;

  // old listings values
  const youtubeLink = publicData?.youtubeLink?.includes('youtube') ? publicData.youtubeLink : null;
  const videoTitle = publicData?.videoTitle;

  if (!youtubeLink && !videos?.length) {
    return null;
  }

  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [videoIndex, setVideoIndex] = useState(null);


  const handleEditPopup = (editPopupStatus, deletePopupStatus, index) => {
    setShowEditPopup(editPopupStatus);
    setShowDeletePopup(deletePopupStatus);
    setVideoIndex(index);
  }

  const handleEditPost = (values) => {
    let data = {
      id,
      publicData: {}
    };

    const updatedVideos = videos.map((v, index) => index == videoIndex ? values : v)
    data.publicData = { videos: !!updatedVideos?.length ? updatedVideos : videos }

    return onUpdateListing('posts', data)
      .then(resp => {
        onLoadData({ id, slug })
        return resp
      })
      .then(resp => {
        setShowEditPopup(false);
        return resp
      })
      .catch(e => console.log(e));
  }

  const handleDeletePost = () => {
    let data = {
      id,
      publicData: {}
    };

    const updatedVideos = videos.filter((item, index) => index !== videoIndex)
    data.publicData = { videos: !!updatedVideos?.length ? updatedVideos : null }

    return onUpdateListing('posts', data)
      .then(resp => {
        onLoadData({ id, slug })
        setShowDeletePopup(false);
        return resp
      })
      .catch(e => console.log(e));
  }

  let videoContent = null;


  // for old listings
  // if (!!youtubeLink) {
  //   const convertedYoutubeLink = youtubeLink
  //     .replace('https://www.youtube.com/', 'https://www.youtube.com/embed/')
  //     .replace('watch?v=', '');
  //   videoContent = (
  //     <div className={css.youtubeSectionWrapper}>
  //       {!!videoTitle && <a className={css.videoLink} href={youtubeLink} target='_blank'>{videoTitle}</a>}
  //       <iframe
  //         width="100%"
  //         height="315"
  //         style={{ marginBottom: '40px', borderRadius: '8px' }}
  //         src={convertedYoutubeLink}
  //         title={videoTitle}
  //         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
  //         allowFullScreen
  //       ></iframe>
  //     </div>
  //   )
  // } else if (!!videos?.length) {
  if (!!videos?.length) {
    videoContent = (
      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: '.custom_next',
          prevEl: '.custom_prev',
        }}
        spaceBetween={10}
        slidesPerView={1.3}
        onSwiper={swiper => { }}
        onSlideChange={() => { }}
        className={css.youtubeSwiper}
      >
        <div className="custom_next">
          <ArrowForwardIosIcon style={{ fontSize: '40px' }} />
        </div>
        <div className="custom_prev">
          <ArrowBackIosNewIcon style={{ fontSize: '40px' }} />
        </div>
        {videos.map((v, index) => {
          const youtubeLink = v?.link?.includes('youtube') || v?.link?.includes('youtu.be') ? v.link : null;

          if (!youtubeLink) {
            return null;
          }

          const convertedYoutubeLink = youtubeLink
            .replace('https://www.youtube.com/', 'https://www.youtube.com/embed/')
            .replace('https://youtu.be/', 'https://www.youtube.com/embed/')
            .replace('watch?v=', '');

          return (
            <SwiperSlide key={`${v.link}-${index}`}>
              <div className={css.youtubeSwiperWrapper}>
                <div className={css.videoLinkWrapper}>
                  {!!youtubeLink &&
                    <a
                      className={css.videoLink}
                      href={youtubeLink}
                      target='_blank'>
                      {v?.title || `Video-${index + 1}`}
                    </a>
                  }
                  {isOwnListing && (
                    <div className={css.actionButtonWrapper}>
                      <span
                        className={css.actionButton}
                        onClick={() => isPreview ? alert(intl.formatMessage({id: 'PreviewPopup.previewMode'})) : handleEditPopup(true, false, index)}
                      >
                        <IconEdit size="big" />
                      </span>
                      <span
                        className={css.actionButton}
                        onClick={() => isPreview ? alert(intl.formatMessage({id: 'PreviewPopup.previewMode'})) : handleEditPopup(false, true, index)}
                      >
                        <IconDelete />
                      </span>
                    </div>
                  )}
                </div>
                <iframe
                  width="100%"
                  height="315"
                  style={{ marginBottom: '40px', borderRadius: '8px' }}
                  src={convertedYoutubeLink}
                  title={v.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    )
  }

  return (
    <>
      <h2 className={css.descriptionTitle}>
        <FormattedMessage id="ListingPage.videoTitle" />
      </h2>
      {videoContent}

      <Modal
        id="YoutubeSection.editPopup"
        isOpen={showEditPopup}
        onClose={() => handleEditPopup(false, null, null)}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <YoutubeSectionForm
          initialValues={videos?.[videoIndex]}
          onSubmit={handleEditPost}
          intl={intl}
        />
      </Modal>

      <Modal
        id="YoutubeSection.deletePopup"
        contentClassName={css.removePostContent}
        isOpen={showDeletePopup}
        onClose={() => setShowDeletePopup(false)}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <p className={css.removePostDescription}>
          <FormattedMessage id="ListingPage.removeVideoDescription" />
        </p>

        <div className={css.removePostButtons}>
          <span
            className={css.removePostButton}
            onClick={() => setShowDeletePopup(false)}
          >
            <FormattedMessage id="ListingPage.removeNo" />
          </span>
          <span
            className={css.removePostButton}
            onClick={() => handleDeletePost()}
          >
            <FormattedMessage id="ListingPage.removeYes" />
          </span>
        </div>
      </Modal>
    </>
  )
};

export default YoutubeSection;
